// extracted by mini-css-extract-plugin
export default {"tabs-list":"components-hotel-and-market-navigation-navigation-main-module__tabs-list","divider":"components-hotel-and-market-navigation-navigation-main-module__divider"};